import React from 'react';
import { TESTIMONIALS, TESTIMONIALS_HEADER } from '../constants';
import { useLanguage } from '../LanguageContext';

const LOGOS = {
  asar: { type: 'text', text: 'ASAR CSG', darkBg: true  },
  dna:  { type: 'img',  src: '/dna/dna24-logo.png', alt: 'DNA 24', darkBg: false },
};

function LogoContent({ logo, variant }) {
  if (logo.type === 'text') {
    return <span className={`pb-logo-text${variant === 'bandeau' ? ' pb-logo-text--lg' : ''}`}>{logo.text}</span>;
  }
  return (
    <img
      src={logo.src}
      alt={logo.alt}
      className={variant === 'bandeau' ? 'pb-trusted-logo-img' : 'pb-testimonial-logo'}
      loading="lazy"
    />
  );
}

export default function Testimonials() {
  const { lang }    = useLanguage();
  const testimonials = TESTIMONIALS[lang];
  const header       = TESTIMONIALS_HEADER[lang];

  return (
    <section className="pb-section pb-section-pad" id="temoignages" data-testid="pb-testimonials">
      <div className="pb-container">

        <div style={{ textAlign: 'center', maxWidth: 520, margin: '0 auto' }}>
          <div className="pb-label" style={{ justifyContent: 'center' }}>{header.label}</div>
          <h2 className="pb-section-title">{header.title}</h2>
          <p className="pb-section-sub" style={{ margin: '16px auto 0', textAlign: 'center' }}>{header.sub}</p>
        </div>

        <div className="pb-trusted-logos" data-testid="pb-trusted-logos">
          {testimonials.map((t, i) => {
            const logo = LOGOS[t.logo];
            return (
              <div key={i} className={`pb-trusted-logo-pill${logo.darkBg ? ' pb-logo-dark' : ' pb-logo-light'}`}>
                <LogoContent logo={logo} variant="bandeau" />
              </div>
            );
          })}
        </div>

        <div className="pb-testimonials-grid">
          {testimonials.map((t, i) => {
            const logo = LOGOS[t.logo];
            return (
              <div key={i} className="pb-testimonial-card" data-testid={`pb-testimonial-${i}`}>
                <div className={`pb-testimonial-logo-wrap${logo.darkBg ? ' pb-logo-dark' : ' pb-logo-light'}`}>
                  <LogoContent logo={logo} variant="card" />
                </div>
                <div className="pb-testimonial-stars" aria-label="5">
                  {[...Array(5)].map((_, s) => <div key={s} className="pb-testimonial-star" />)}
                </div>
                <blockquote className="pb-testimonial-quote">&ldquo;{t.quote}&rdquo;</blockquote>
                <div className="pb-testimonial-author">
                  <div>
                    <div className="pb-testimonial-name">{t.company}</div>
                    <div className="pb-testimonial-role">{t.role}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
